import { RefundMethodType } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

import { TextView } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type AdvancePaymentRefundToBeCreatedTypeTextViewProps = Readonly<{
   refundToBeCreatedMethodType: RefundMethodType | null | undefined;
}>;

export const AdvancePaymentRefundToBeCreatedTypeTextView = (
   props: AdvancePaymentRefundToBeCreatedTypeTextViewProps
): JSX.Element | null => {
   if (!props.refundToBeCreatedMethodType) {
      return null;
   }

   return (
      <TextView
         testId={'refundToBeCreatedMethodType'}
         label={translationKeys.advancePaymentRefundToBeCreatedMethodType}
      >
         <Translate>{translationKeys.refundMethodTypeMap[props.refundToBeCreatedMethodType]}</Translate>
      </TextView>
   );
};
